// Thumbnails slider
const pdpThumbnails = document.querySelector('.pdp-thumbnails__swiper');
if (pdpThumbnails) {
  const pdpThumbnailSlider = new Swiper(pdpThumbnails, {
    draggable: true,
    direction: 'vertical',
    freeMode: true,
    mousewheel: true,
    slidesPerView: 'auto',
  });
}

const pdpSliderMain = document.querySelector('.pdp-slider');
if (pdpSliderMain) {
  function handleResize() {
    if (pdpThumbnails && pdpSliderMain) {
      const firstImage = pdpSliderMain.querySelector('.swiper-slide img');

      if (firstImage) {
        const imageHeight = firstImage.getBoundingClientRect().height;
        pdpThumbnails.style.height = `${imageHeight}px`;
      }
    }
  }

  // Set height on initial load
  handleResize();

  // Update height on resize
  window.addEventListener('resize', handleResize);
}

// Main product slider
const pdpSlider = new Swiper('.pdp-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  navigation: {
    prevEl: '.product .swiper-button-prev',
    nextEl: '.product .swiper-button-next',
  },
});

// Sync slider with thumbnails
pdpSlider.on('slideChange', slider => {
  let idx = slider.realIndex;
  const activeThumb = document.querySelector('.pdp-thumbnail.active');
  const newThumb = document.querySelector(`.pdp-thumbnail[data-index="${idx}"]`);
  
  activeThumb.classList.remove('active');
  newThumb.classList.add('active');
});

// Sync thumbnails with slider
const thumbnailContainer = document.querySelector('.pdp-thumbnails')
thumbnailContainer.addEventListener('click', event => {
  const button = event.target.closest('.pdp-thumbnail');
  if (button) {
    let idx = Number(button.dataset.index);
    pdpSlider.slideToLoop(idx);
  }
});

// Size Guide
const sizeGuide = document.querySelector('.size-guide');
if(sizeGuide){
  document.querySelector('.size-guide-trigger').addEventListener('click', event => {
    event.preventDefault();
  
    sizeGuide.classList.remove('invisible', 'opacity-0');
    document.body.classList.add('overflow-hidden');
  });
}

const closeButtons = document.querySelectorAll('.size-guide-close');
closeButtons.forEach(button => {
  button.addEventListener('click', event => {
    event.preventDefault();
  
    sizeGuide.classList.add('invisible', 'opacity-0');
    document.body.classList.remove('overflow-hidden');
  });
})

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const formData = JSON.parse(serializeForm(this.form));
    const properties = {};
    for (const [key, value] of Object.entries(formData)) {
      if (key.startsWith('properties[') && key.endsWith(']')) {
        const propertyKey = key.slice(11, -1);
        properties[propertyKey] = value;
        delete formData[key];
      }
    }

    if(window.trynow) {
      const sellingPlan = await window.trynow.getSellingPlanId();
      const sellingPlanId = sellingPlan.split('/').pop();
  
      if (
          formData.selling_plan &&
          formData.selling_plan !== '' &&
          formData.selling_plan === sellingPlanId
        ) {
          delete properties['_LPROP'];
        }
    }
    
    const body = JSON.stringify({
      ...formData,
      properties,  // Add properties object
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });


    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '#cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '#cart-icon-bubble'
      },
      {
        id: 'cart-count',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '#cart-count',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            const selects = this.querySelectorAll('select');
            selects.forEach(select => {
              select.addEventListener('change', this.handleSelect.bind(this));
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }

  handleSelect(event) {
    const id = event.currentTarget.value;
    const button = event.currentTarget.parentElement.nextElementSibling;

    button.setAttribute('data-id', id)
  }
}

customElements.define('product-recommendations', ProductRecommendations);
